<div class="header d-none d-md-block">
  <h1 class="d-inline-flex v-align-middle astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'PRINT_ORDER.HEADER_TOOLTIP'"></astral-popover>
  </h1>
</div>
<div class="header d-flex d-md-none align-items-center">
  <h1 class="w-100 astral-heading-with-help">
    <span>{{ title | translate }}</span>
    <astral-popover [helpText]="'PRINT_ORDER.HEADER_TOOLTIP'"></astral-popover>
  </h1>
</div>

<app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

<app-list-view
  [columnDefinition]="columnDefinition"
  [contextMenuDefinition]="contextMenuDefinition"
  [itemsSource]="itemsSource"
  [preferencesKey]="preferencesKey"
>
</app-list-view>
